export const locale = {
  lang: 'zh2',
  data: {
    'LANDINFOCUS': {
      'ENCUESTAS':{
        'TITULO':'这是重点领域的过程',
        'NO-ENCU':'您当前没有分配的调查流程',
        'ENC-AUTO':'授权调查',
        'ENC-CORRECI':'调查报告已送交更正',
        'MODAL_NO_COLAB_EMPRE':'您尚未上传您的贡献者库，确定要继续吗？',

      },
      'STATUS-ENCUESTA':{
        '1':'处理中',
        '2':'评估',
        '3':'授权',
        '5':'正确',

      },
      'LISTA': {
        'TAB': '参赛者名单',
        'BUSCAR': {
          'INFO': '您可以通过输入以下名称从列表中搜索一个或多个参与者',
          'PLACEHOLDER': '寻找参加者'
        },
        'AGREGAR': {
          'BOTON': '添加参与者'
        },
        'TABLA': {
          'COLUMNAS': {
            'NOMBRE': '全名',
            'EMAIL': '电子邮件',
            'ACCIONES': '可用操作'
          }
        },
        'TOOLTIPS': {
          'AGREGAR': '将参与者添加到列表中',
          'EDITAR': '编辑此参与者数据'
        }
      },
      'MODALES':{
        'CREARENC': '输入调查名称',
        'CORRECTO': '已正确添加',
        'COMDELETE': '正确删除',
        'DELETE': '你真的想消除',
        'RSPSI':'是',
        'RSPNO':'没有',
        'RSPOK':'好',
        'RSPACEPTAR':'接受',
        'CARGANDOLISTA': '正在获取参与者列表，请稍等'
      },
      'WIZARD':{
        'CARGANDOF': '加载获取的产品',
        'SINPRODS': '您尚未购买此产品',
        'CREARENC': '创建调查',
        'DONE': '申请年份',
        'TITULO': '欢迎来到重点领域',
        'TFOCUS': '调查到重点区域',
        'DELETE': '删除',
        'EDIT': '编辑',
        'VERIPRE':'检查问题',
        'AVANCE':'预先',
        'TITUVERI':'验证问题',
        'TITUTABTEM':'有关模板的问题',
        'TITUTABADI':'个性化问题',
        'TITUTAUTORIZADA':'授权调查',
        'TITUTNOAUTORIZADA':'取消调查授权',
        'TITUTAUTORIZAR':'授权调查',
        'TITUTCORREGIR':'正确的调查',
      },
      'TABLACAMPOS':{
        'NAME':'调查名称',
        'FECHAI':'开始日期',
        'FECHAF':'目标日期',
        'AVANCE':'预先',
        'ESTADO': '状态',
        'ACCION': '行为',
      },
      'COLABORADORES':{
        'CARGACOLAB':'上传认证合作者'
      },
      'ADMIN-PREG':{
        'TITULO-ABIE':'公开问题',
        'PREGUN':'问题',
        'PREGUNSUB':'题',
        'DESCRIP-PREGUN':'点击此处显示问题',
        'TITULO-UNAOPC':'一选题',
        'TITULO-MULOPC':'多项选择题',
        'OPC':'选件',
        'OPCSUB':'选项',
        'NO-ADICI':'该调查没有其他问题',
      },
      'STEP_COLAB':{
        'STEP_1':{
          'TITULO_STEP_ELEGIR_COLAB':'合作者的选择类型',
          'INST_1':'选择以下选项之一',
          'NUEVA_BASE_COLA':'上载新的贡献者库',
          'BASE_COLAB_EXIS':'使用主要贡献者库',
          'BTN_SIGUENTE':'下一个',

        },
        'STEP_2':{
          'TITULO_STEP_SUBIR_COLAB':'贡献者的选择',
          'MAT_TITLE_DEMO_SELE':'选定的受众特征',
          'ALERT_NOT_DEMO_SELE':'您尚未选择过滤器',
          'ALERT_NOT_SELE_COLAB':'未添加合作者',
          'AGREGAR_FILTRO':'添加过滤器',
          'TH_NOMBRE':'贡献者姓名',
          'TH_ACCION':'动作',
          'INTS_SEL_1_O_MAS_COLAB':'*注意：选择一个或多个合作者',
          'SIN_RESULTADOS':'当前的过滤器选择未返回任何结果，请尝试更改过滤器，然后重试',
          'BTN_REGRESAR':'返回',
          'BTN_AGRE_COLAB':'添加合作者',
          'BTN_GUAR_COLAB':'保存合作者',
          'BTN_BORR_COLAB':'删除合作者',
          'BTN_ACEPTAR':'接受',
          'BTN_BUSCAR':'搜索',
          'TITULO_MODAL_DEMOGRA':'人口统计清单',
          'MAT_TITLE_EXPA_RESULT':'贡献者搜索结果：',
          'MAT_TITLE_EXPA_AGREG':'总体合作者：',
          'MAT_TITLE_EXPA_DESCRIP':'见合作者',
          'MODALES':{
            'MODAL_CARGAN_FILTROS':'加载过滤器',
            'MODAL_BUSCA_COLAB':'搜索过滤的协作者',
            'MODAL_AGRE_COLAB':'添加合作者',
            'MODAL_DELET_COLAB':'删除合作者信息',
            'MODAL_SUCCES_AGRE_COLAB':'协作者已成功添加',
            'MODAL_GUAR_COLAB':'节省合作者',
            'MODAL_CONFIR_BORRAR_COLAB':'您确定要删除贡献者吗？',
            'MODAL_CONFIR_BORRAR_COLABRES':'您确定要删除协作者吗？',
            'MODAL_CONFIR_GUAR_COLAB_BACK':'您确定要保存添加的协作者吗？',
            'MODAL_SUCCES_GUAR_COLAB':'合作伙伴已正确保存',
            'MODAL_SUCCES_BORRA_COLAB':'贡献者已正确删除',
            'MODAL_SUCCES_BORRA_COLABRES':'贡献者已成功删除',
            'MODAL_WARNN_NO_SELECT_COLAB':'您尚未选择任何协作者',
            'BTN_SI':'是的',
            'BTN_NO':'不要',
            'BTN_OK':'好的',
          },
          'FORMULARIO':{
            'fullName': '全名',
            'ownKey': '员工编号',
            'age': '出生年份',
            'surveyKey': '调查访问密钥',
            'email': '电子邮件',
            'bossName': '直接老板姓名',
            'bossKey': '直接老板号码',
            'country': '国家',
            'location': '位置',
            'geo_1': '地理等级1',
            'geo_2': '地理等级2',
            'geo_3': '地理级别3',
            'geo_4': '地理等级4',
            'geo_5': '地理等级5',
            'geo_6': '地理等级6',
            'geo_7': '地理等级7',
            'geo_8': '地理级别8',
            'geo_9': '地理等级9',
            'geo_10': '地理级别10',
            'structure_1': '结构一级',
            'structure_2': '结构等级2',
            'structure_3': '结构等级3',
            'structure_4': '结构等级4',
            'structure_5': '结构等级5',
            'structure_6': '结构等级6',
            'structure_7': '结构等级7',
            'structure_8': '结构等级8',
            'structure_9': '结构层9',
            'structure_10': '结构层10',
            'area': '区',
            'bUnit': '业务部门',
            'enterDate': '进入公司的日期',
            'antiquity': '古代',
            'antiquityUS': '上古我们',
            'generation': '代',
            'generationUS': '一代我们',
            'ageUS': '年龄',
            'charge': '在公司中的职位或职能',
            'homologado': '充电或功能批准',
            'homologadoUS': '收费或功能批准了我们',
            'gender': '性别',
            'genderType': '性别类型',
            'typeofwork': '补偿类型',
            'workCondition': '工作条件',
            'academico': '学位',
            'contratacion': '合同类型',
            'situacionUS': '我们的工作情况',
            'personal': '员工类型',
            'jornada': '工作时间表类型',
            'rotacion': '确实旋转',
            'phone': '合作者的电话',
            'extension': '合作者的直接扩展',
            'cellphone': '合作者的手机',
            'native': '母语',
            'answer': '回答',
            'other_1': '其他1',
            'other_2': '其他2',
            'other_3': '其他3',
            'other_4': '其他4',
            'other_5': '其他5',
            'other_6': '其他6',
            'other_7': '其他7',
            'other_8': '其他8',
            'other_9': '其他9',
            'other_10': '其他10',
          },
        },
    }

    }
  }
};
